/**
 * Native push notifications (FCM on Android, APNs via FCM on iOS). The device token is registered with the
 * server, which sends pushes for invitations, friend requests, "your turn", rewards… respecting the
 * player's notification categories.
 */
import { api } from '../api/client';
import { isNative, platform } from './platform';

let registered = false;

export async function registerPush(onOpen: (path: string) => void): Promise<void> {
  if (!isNative || registered) return;
  registered = true;
  const { PushNotifications } = await import('@capacitor/push-notifications');
  let perm = await PushNotifications.checkPermissions();
  if (perm.receive === 'prompt' || perm.receive === 'prompt-with-rationale') perm = await PushNotifications.requestPermissions();
  if (perm.receive !== 'granted') return;
  await PushNotifications.addListener('registration', (token) => {
    void api.post('/api/v1/push-tokens', { token: token.value, platform }).catch(() => undefined);
  });
  await PushNotifications.addListener('registrationError', () => {
    registered = false;
  });
  await PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    const data = action.notification.data as Record<string, string> | undefined;
    if (data?.code) onOpen(`/rooms/${data.code}`);
    else if (data?.tableId) onOpen(`/table/${data.tableId}`);
    else if (data?.route) onOpen(data.route);
  });
  await PushNotifications.register();
}
